import { Tooltip } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';

import { Condition } from 'Component/others';
import { TextRegular } from './index';

const TruncatedText = ({ children, className = '', ...props }) => {
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current && children) {
        const element = textRef.current;
        const isOverflow = element.scrollHeight > element.clientHeight + 2;
        setIsOverflowing(isOverflow);
      }
    };

    const timeoutId = setTimeout(checkOverflow, 100);

    window.addEventListener('resize', checkOverflow);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', checkOverflow);
    };
  }, [children]);

  const textContent = (
    <TextRegular
      ref={textRef}
      className={className}
      {...props}
    >
      {children}
    </TextRegular>
  );

  return (
    <Condition
      statement={isOverflowing && children}
      fallback={textContent}
    >
      <Tooltip
        label={children}
        placement="top"
        hasArrow
        bg="gray.700"
        color="white"
        fontSize="sm"
        borderRadius="4px"
        maxWidth="300px"
        whiteSpace="normal"
        textAlign="left"
      >
        {textContent}
      </Tooltip>
    </Condition>
  );
};

export default TruncatedText;
